'use strict';

const valuesAreSet = (values) => {
  return values && values.length > 0;
};

const valuesExpressionIsSet = (expression) => {
  return expression !== null && expression !== undefined && expression !== '';
};

const expressionRegex = /^\{\{(prozessparameter|prozessinstanzvariable):[^}]+\}\}$/;

const isValidExpression = (value) => {
  return valuesExpressionIsSet(value) && expressionRegex.test(value);
};

const valuesExpressionMatchesPattern = (expression) => {
  if (valuesExpressionIsSet(expression) && !isValidExpression(expression)) {
    alert(
      'Der Platzhalter ist ungültig. Bitte geben Sie einen gültigen Platzhalterausdruck an, z.B. {{prozessinstanzvariable:meineVariable}}'
    );
    return false;
  }
  return true;
};

const noValuesSetBesidesValuesExpression = (values) => {
  if (valuesAreSet(values) && values.every((value) => value)) {
    alert(
      'Sie haben Wert(e) und Platzhalter gleichzeitig definiert. Bitte setzen Sie nur für einen der beiden Felder einen Wert.'
    );
    return false;
  }
  return true;
};

const valuesExpressionIsValid = (values, valuesExpression) => {
  return noValuesSetBesidesValuesExpression(values) && valuesExpressionMatchesPattern(valuesExpression);
};

const unterscheidungszeichenRegex = /^[a-zäöü]{1,3}$/i;

const unterscheidungszeichenIsValid = (value) => {
  return unterscheidungszeichenRegex.test(value) || isValidExpression(value);
};

module.exports = {
  valuesExpressionIsValid: valuesExpressionIsValid,
  valuesAreSet: valuesAreSet,
  valuesExpressionIsSet: valuesExpressionIsSet,
  valuesExpressionMatchesPattern: valuesExpressionMatchesPattern,
  unterscheidungszeichenIsValid: unterscheidungszeichenIsValid,
  isValidExpression: isValidExpression
};
